import { Progress, Table } from "reactstrap";
import { Fragment } from "react";
import { H5, Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { TRANSACTION_DATA_TABLE } from "../../../../Data/Dashboard";

export const TransactionHistoryTable = () => {
  return (
    <Table className="display dataTable mt-2 mb-2" id="transaction">
      {TRANSACTION_DATA_TABLE.map((item, index) => (
        <Fragment key={index}>
          <thead>
            <tr>{item.heading.map((head, id) => (<th key={id} className={head.classname ? head.classname : ""}>{head.text}</th>))}</tr>
          </thead>
          <tbody>
            {item.items.map((value, number) => (
              <tr key={number}>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0"><Image src={dynamicImage(`dashboard/user/${value.image}`)} alt="" /></div>
                    <div className="flex-grow-1 ms-2">
                      <Link to={`${process.env.PUBLIC_URL}/ecommerce/product`}>
                        <H5>{value.title}</H5>
                        <span>{value.spanText}</span>
                      </Link>
                    </div>
                  </div>
                </td>
                <td><div className="flex-grow-1 ms-2"><H5>{value.date}</H5><span>{value.time}</span></div></td>
                <td><H5>{value.amount}</H5></td>
                <td><P>{value.code}</P></td>
                <td><Progress color={value.color} style={{ height: "6px", }} value={value.value} /></td>
                <td><H5>{value.payment}</H5></td>
              </tr>
            ))}
          </tbody>
        </Fragment>
      ))}
    </Table>
  );
};
